import React from 'react';
import PropTypes from 'prop-types';

// @mui
import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

// icons
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// ----------------------------------------------------------------------

const RootStyle = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: 0,
}));

// ----------------------------------------------------------------------

export function StepActions({
  showBack = false,
  onBack,
  onNext,
  isNextLoading = false,
  isLastStep = false,
  nextButtonText = 'Suivant',
  backButtonText = 'Retour',
  disableNext = false, // Nouvelle prop
}) {
  return (
    <RootStyle>
      <Box>
        {showBack && (
          <Button
            color="inherit"
            onClick={onBack}
            startIcon={<ArrowBackIcon />}
            disabled={isNextLoading}
            size="medium"
          >
            {backButtonText}
          </Button>
        )}
      </Box>

      <Box>
        <Button
          variant="contained"
          onClick={onNext}
          disabled={isNextLoading || disableNext} // Ajout de disableNext ici
          endIcon={
            isNextLoading ? (
              <CircularProgress size={16} color="inherit" />
            ) : isLastStep ? (
              <CheckCircleIcon fontSize="small" />
            ) : (
              <ArrowForwardIcon fontSize="small" />
            )
          }
          size="medium"
        >
          {nextButtonText}
        </Button>
      </Box>
    </RootStyle>
  );
}

StepActions.propTypes = {
  showBack: PropTypes.bool,
  onBack: PropTypes.func,
  onNext: PropTypes.func.isRequired,
  isNextLoading: PropTypes.bool,
  isLastStep: PropTypes.bool,
  nextButtonText: PropTypes.string,
  backButtonText: PropTypes.string,
  disableNext: PropTypes.bool, // Nouvelle prop
};
